import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { useState } from 'react';
export const THEME_STORAGE_KEY = 'previxio-theme';
// Chiave della webapp prima del rebrand: la preferenza salvata lì si porta
// sulla chiave nuova una sola volta, prima che next-themes la legga.
export const LEGACY_THEME_STORAGE_KEY = 'nuflow-theme';
const THEMES = ['light', 'dark'];
export function migrateLegacyThemeKey(storage) {
    const legacyTheme = storage.getItem(LEGACY_THEME_STORAGE_KEY);
    if (legacyTheme && !storage.getItem(THEME_STORAGE_KEY)) {
        storage.setItem(THEME_STORAGE_KEY, legacyTheme);
        storage.removeItem(LEGACY_THEME_STORAGE_KEY);
    }
}
// Inizializzatore di useState: gira una volta al montaggio, prima che il
// provider di next-themes legga la preferenza dal proprio stato iniziale.
const migrateBrowserTheme = () => {
    if (typeof window !== 'undefined') {
        migrateLegacyThemeKey(window.localStorage);
    }
    return true;
};
export function ThemeProvider({ children }) {
    useState(migrateBrowserTheme);
    return (_jsx(NextThemesProvider, { attribute: "class", defaultTheme: "light", enableSystem: false, disableTransitionOnChange: true, themes: THEMES, storageKey: THEME_STORAGE_KEY, children: children }));
}
//# sourceMappingURL=theme-provider.js.map